<template>
  <div class="slider-component-container" ref="sliderContainer">
    <div style="position: relative">
      <div class="slider-container d-flex" v-for="(slider, index) in sliders" :key="index">
        <div
          :id="slider.id"
          :style="{ left: slider.pxposition }"
          class="slider"
          ref="slidersElement"
          @mousedown="dragMouseDown"
        >
          <div class="slider-value-container">
            <div class="slider-value-icon">&lt; &gt;</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button class="add-division-button" @click="addDivision"><i class="icon-plus"></i></button>
</template>

<script>
let currX = 0,
  initialX = 0,
  usedBarSpace = 0,
  element,
  pixelsPerHectare;
export default {
  props: {
    divisionsSizeArray: Array,
    totalSize: Number,
  },
  name: "Multislider",
  data() {
    return {
      sliders: [],
      sliderWidth: 1,
    };
  },
  mounted() {
    this.initSliders();
  },
  computed: {
    fatherDivWidth() {
      if (!this.$refs.sliderContainer) {
        return 0;
      } else {
        return this.$refs.sliderContainer && this.$refs.sliderContainer.offsetWidth;
      }
    },
    availableBarWidth() {
      return this.fatherDivWidth - this.sliderWidth;
    },
  },
  methods: {
    addDivision() {
      if (this.sliders.length === 4) return;

      console.log(this.sliders);

      let lastDivision = this.sliders[this.sliders.length - 1];
      // const pxPosition = this.calculateInitialDOMPosition(this.divisionsSizeArray[i]);
      const newDivision = {
        id: parseInt(lastDivision.id) + 1,
        size: lastDivision.size / 2,
        // pxposition: `${pxPosition}px`,
        // position: pxPosition / pixelsPerHectare
      };

      this.sliders.push(newDivision);

      console.log(this.sliders);

      newDivision.pxPosition = this.calculateInitialDOMPosition(newDivision);
      newDivision.position = newDivision.pxPosition / pixelsPerHectare;

      lastDivision.size /= 2;
      lastDivision.pxPosition = this.calculateInitialDOMPosition(lastDivision);
      lastDivision.position = lastDivision.pxPosition / pixelsPerHectare;
    },
    dragMouseDown(e) {
      element = e.currentTarget;
      console.log(element);
      e.preventDefault();
      e.stopPropagation();
      // get the mouse cursor position at startup:
      initialX = e.clientX;
      document.onmouseup = this.closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = this.elementDrag;
    },
    elementDrag(e) {
      // calculate the new cursor position:
      currX = initialX - e.clientX;
      initialX = e.clientX;
      // Define min and max values for in the X coordinate for element
      const slidersDOMArray = this.$refs.slidersElement;
      const elementIndex = slidersDOMArray.findIndex((slider) => slider.id == element.id);
      if (elementIndex === this.sliders.length - 1) return; // Shouldn't be able to drag the last one
      let minX = 0,
        maxX = 0;
      if (slidersDOMArray.length > 1) {
        if (elementIndex == 0) {
          minX = 0;
          maxX = parseInt(slidersDOMArray[1].style.left.replace("px", "")) - this.sliderWidth;
        } else if (elementIndex == slidersDOMArray.length - 1) {
          minX = parseInt(slidersDOMArray[elementIndex - 1].style.left.replace("px", "")) + this.sliderWidth;
          maxX = this.availableBarWidth;
        } else {
          minX = parseInt(slidersDOMArray[elementIndex - 1].style.left.replace("px", "")) + this.sliderWidth;
          maxX = parseInt(slidersDOMArray[elementIndex + 1].style.left.replace("px", "")) - this.sliderWidth;
        }
      } else {
        minX = 0;
        maxX = this.availableBarWidth;
      }

      // Set the element's new position, but with the min and max contrains
      const newPositionX = Math.max(Math.min(element.offsetLeft - currX, maxX), minX);

      element.style.left = `${newPositionX}px`; //update position
      //update positions array
      this.sliders = this.updateSlidersData(slidersDOMArray);
    },
    closeDragElement() {
      // stop moving when mouse button is released:
      document.onmouseup = null;
      document.onmousemove = null;
    },
    initSliders() {
      for (let i = 0; i < this.divisionsSizeArray.length; i++) {
        const pxPosition = this.calculateInitialDOMPosition(this.divisionsSizeArray[i]);
        this.sliders[i] = {
          index: i,
          id: this.divisionsSizeArray[i].id,
          pxposition: `${pxPosition}px`,
          position: pxPosition / pixelsPerHectare,
        };
        this.sliders[i].valueInBar = this.valueInBar(this.divisionsSizeArray[i]); // Why not just use this.divisionsSizeArray[i].size?
      }
    },
    calculateInitialDOMPosition(division) {
      pixelsPerHectare = this.availableBarWidth / this.totalSize; // like "30px / 1 hectare"
      const spaceTakenCurrentSlider = pixelsPerHectare * division.size;
      const leftPosition = spaceTakenCurrentSlider + usedBarSpace;
      usedBarSpace += spaceTakenCurrentSlider;
      return leftPosition;
    },
    valueInBar(slider) {
      const sliderIndex = this.sliders.findIndex((el) => el.id == slider.id);
      if (!this.sliders[sliderIndex] || !pixelsPerHectare) {
        return 0;
      }
      const sliderWidthInHectares = this.sliderWidth / pixelsPerHectare;
      const currentSliderPos = this.sliders[sliderIndex].position;
      if (sliderIndex - 1 < 0) {
        return currentSliderPos.toFixed(0) > 0 ? currentSliderPos.toFixed(0) : currentSliderPos.toFixed(2);
      }
      const formerSliderPos = this.sliders[sliderIndex - 1].position;
      let valueInBar =
        (currentSliderPos - formerSliderPos - sliderWidthInHectares).toFixed(0) > 0
          ? (currentSliderPos - formerSliderPos - sliderWidthInHectares).toFixed(0)
          : (currentSliderPos - formerSliderPos - sliderWidthInHectares).toFixed(2);
      return valueInBar;
    },
    updateSlidersData(sliderDOMElements, initialPositions) {
      const updatedSliders = sliderDOMElements.map((slider, index) => {
        return {
          index,
          id: slider.id,
          pxposition: initialPositions ? initialPositions[index] : slider.style.left,
          position: parseInt(slider.style.left.replace("px", "")) / pixelsPerHectare,
          valueInBar: this.valueInBar(slider),
        };
      });
      this.$emit("slidersUpdated", updatedSliders);
      return updatedSliders;
    },
  },
};
</script>

<style scoped>
.add-division-button {
  border: var(--light-gray);
  background-color: var(--light-gray);
  width: 2rem;
  height: 2rem;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  margin-left: 1rem;
}

.slider-component-container {
  height: 100px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: none !important;
}

.slider-container {
  background-color: #d5d5d5;
  width: 100%;
  height: 32px;
  border: 1px solid #d5d5d5;
  position: absolute;
  border-radius: var(--main-border-radius);
}

.slider {
  background-color: grey;
  height: 30px;
  width: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
  position: relative;
  z-index: 2;
  font-size: xx-large;
}

.slider-value-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.slider-value-icon {
  font-size: 20px;
  text-align: center;
  width: 40px;
  cursor: default;
}

.slider-value-text {
  font-size: 15px;
  text-align: left;
  display: flex;
}

.slider-leyend {
  z-index: 1;
  color: black;
  font-size: 13px;
  font-weight: bold;
  margin: 1px 8px;
}

div.relative {
  position: relative;
}

div.absolute {
  position: absolute;
}
</style>
